import { Typography, Box, SxProps, Theme } from "@mui/material"
import DoneIcon from "./icon/DoneIcon.svg"
import AlertIcon from "assets/svg/Alert.svg"
import DisableIcon from "./icon/DisableIcon.svg"
import ChargingIcon from "./icon/ChargingIcon.svg"
import ValidationIcon from "./icon/ValidationIcon.svg"
import ErrorIcon from "./icon/ErrorIcon.svg"
import WaitingIcon from "./icon/WaitingIcon.svg"
import WarningIcon from "./icon/WarningIcon.svg"
import DeliveryIcon from "./icon/DeliveryIcon.svg"
import HeadOfficeIcon from "./icon/HeadOfficeIcon.svg"
import BillingMethodIcon from "./icon/BillingMethodIcon.svg"

const StatusDone = (props: { text: string; sx?: SxProps }) => {
    const { text, sx } = props
    if (text === undefined || text.length == 0) return null
    return (
        <Box
            data-testid="status-done"
            sx={{
                width: "fit-content",
                height: "32px",
                borderRadius: "8px",
                backgroundColor: "grey.100",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                paddingLeft: "10px",
                paddingRight: "12px",
                paddingY: "4px",
                ...sx,
            }}
        >
            <img
                src={DoneIcon}
                alt="Done"
                style={{ marginRight: "8px", width: "18px", height: "18px" }}
            />
            <Typography
                variant="h5"
                sx={{
                    whiteSpace: "nowrap",
                    color: "grey.600",
                    fontFamily: "Roboto",
                    fontWeight: 500,
                    fontSize: "14px",
                    lineHeight: "18px",
                    letterSpacing: "0.1px",
                    textAlign: "center",
                }}
            >
                {text}
            </Typography>
        </Box>
    )
}

const StatusFailed = (props: { text: string; sx?: SxProps }) => {
    const { text, sx } = props
    if (text === undefined || text.length == 0) return null
    return (
        <Box
            data-testid="status-done"
            sx={{
                width: "fit-content",
                height: "32px",
                borderRadius: "8px",
                backgroundColor: "status.error",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                paddingLeft: "10px",
                paddingRight: "12px",
                paddingY: "4px",
                ...sx,
            }}
        >
            <img
                src={AlertIcon}
                alt="Done"
                style={{ marginRight: "8px", width: "18px", height: "18px" }}
            />
            <Typography
                variant="h5"
                sx={{
                    whiteSpace: "nowrap",
                    color: "error.main",
                    fontFamily: "Roboto",
                    fontWeight: 500,
                    fontSize: "14px",
                    lineHeight: "18px",
                    letterSpacing: "0.1px",
                    textAlign: "center",
                }}
            >
                {text}
            </Typography>
        </Box>
    )
}

const StatusDisable = (props: { text: string; sx?: SxProps<Theme> }) => {
    const { text, sx = {} } = props;
    if (text === undefined || text.length == 0) return null
    return (
        <Box
            data-testid="status-disable"
            sx={{
                width: "fit-content",
                height: "18px",
                borderRadius: "8px",
                backgroundColor: "grey.100",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                paddingLeft: "10px",
                paddingRight: "12px",
                paddingY: "4px",
                ...sx,
            }}
        >
            <img
                src={DisableIcon}
                alt="Disable"
                style={{ marginRight: "8px", width: "18px", height: "18px" }}
            />
            <Typography
                variant="h5"
                sx={{
                    whiteSpace: "nowrap",
                    color: "grey.600",
                    fontFamily: "Roboto",
                    fontWeight: 500,
                    fontSize: "14px",
                    lineHeight: "18px",
                    letterSpacing: "0.1px",
                    textAlign: "center",
                }}
            >
                {text}
            </Typography>
        </Box>
    )
}

const StatusCharging = (props: { text: string; sx?: SxProps }) => {
    const { text, sx } = props
    if (text === undefined || text.length == 0) return null

    return (
        <Box
            data-testid="status-charging"
            sx={{
                width: "fit-content",
                height: "18px",
                borderRadius: "8px",
                backgroundColor: "status.success",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                paddingLeft: "10px",
                paddingRight: "12px",
                paddingY: "4px",
                position: "relative",
                ...sx,
            }}
        >
            <img
                src={ChargingIcon}
                alt="Charging"
                style={{ marginRight: "8px", width: "18px", height: "18px" }}
            />
            <Typography
                variant="h5"
                sx={{
                    whiteSpace: "nowrap",
                    color: "secondary.main",
                    fontFamily: "Roboto",
                    fontWeight: 500,
                    fontSize: "14px",
                    lineHeight: "18px",
                    letterSpacing: "0.1px",
                    textAlign: "center",
                }}
            >
                {text}
            </Typography>
        </Box>
    )
}

const StatusValidation = (props: { text: string; sx?: SxProps<Theme> }) => {
    const { text, sx = {} } = props;
    if (text === undefined || text.length == 0) return null

    return (
        <Box
            data-testid="status-validation"
            sx={{
                width: "fit-content",
                height: "18px",
                borderRadius: "8px",
                backgroundColor: "status.success",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                paddingLeft: "10px",
                paddingRight: "12px",
                paddingY: "4px",
                ...sx,
            }}
        >
            <img
                src={ValidationIcon}
                alt="Validation"
                style={{ marginRight: "8px", width: "18px", height: "18px" }}
            />
            <Typography
                variant="h5"
                sx={{
                    whiteSpace: "nowrap",
                    color: "secondary.main",
                    fontFamily: "Roboto",
                    fontWeight: 500,
                    fontSize: "14px",
                    lineHeight: "18px",
                    letterSpacing: "0.1px",
                    textAlign: "center",
                }}
            >
                {text}
            </Typography>
        </Box>
    )
}

const StatusWaiting = (props: { text: string; sx?: SxProps }) => {
    const { text, sx } = props
    if (text === undefined || text.length == 0) return null

    return (
        <Box
            data-testid="status-waiting"
            sx={{
                width: "fit-content",
                height: "32px",
                borderRadius: "8px",
                backgroundColor: "status.warning",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                paddingLeft: "10px",
                paddingRight: "12px",
                paddingY: "4px",
                ...sx,
            }}
        >
            <img
                src={WaitingIcon}
                alt="Waiting"
                style={{ marginRight: "8px", width: "18px", height: "18px" }}
            />
            <Typography
                variant="h5"
                sx={{
                    whiteSpace: "nowrap",
                    color: "waiting.main",
                    fontFamily: "Roboto",
                    fontWeight: 500,
                    fontSize: "14px",
                    lineHeight: "18px",
                    letterSpacing: "0.1px",
                    textAlign: "center",
                }}
            >
                {text}
            </Typography>
        </Box>
    )
}

const StatusError = (props: { text: string; sx?: SxProps }) => {
    const { text, sx } = props
    if (text === undefined || text.length == 0) return null

    return (
        <Box
            data-testid="status-error"
            sx={{
                width: "fit-content",
                height: "32px",
                borderRadius: "8px",
                backgroundColor: "status.error",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                paddingLeft: "10px",
                paddingRight: "12px",
                paddingY: "4px",
                ...sx,
            }}
        >
            <img
                src={ErrorIcon}
                alt="Error"
                style={{ marginRight: "8px", width: "18px", height: "18px" }}
            />
            <Typography
                variant="h5"
                sx={{
                    whiteSpace: "nowrap",
                    color: "error.main",
                    fontFamily: "Roboto",
                    fontWeight: 500,
                    fontSize: "14px",
                    lineHeight: "18px",
                    letterSpacing: "0.1px",
                    textAlign: "center",
                }}
            >
                {text}
            </Typography>
        </Box>
    )
}

const StatusWarning = (props: { text: string; sx?: SxProps }) => {
    const { text, sx } = props
    if (text === undefined || text.length == 0) return null

    return (
        <Box
            data-testid="status-error"
            sx={{
                width: "fit-content",
                height: "32px",
                borderRadius: "8px",
                backgroundColor: "status.warning",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                paddingLeft: "10px",
                paddingRight: "12px",
                paddingY: "4px",
                ...sx,
            }}
        >
            <img
                src={WarningIcon}
                alt="Error"
                style={{ marginRight: "8px", width: "18px", height: "18px" }}
            />
            <Typography
                variant="h5"
                sx={{
                    color: "waiting.main",
                    fontFamily: "Roboto",
                    fontWeight: 500,
                    fontSize: "14px",
                    lineHeight: "18px",
                    letterSpacing: "0.1px",
                    textAlign: "center",
                }}
            >
                {text}
            </Typography>
        </Box>
    )
}

const StatusDeliveryMethod = (props: { text: string; sx?: SxProps }) => {
    const { text, sx } = props
    if (text === undefined || text.length == 0) return null

    return (
        <Box
            data-testid="status-delivery-method"
            sx={{
                width: "fit-content",
                height: "32px",
                borderRadius: "8px",
                backgroundColor: "grey.200",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                paddingLeft: "10px",
                paddingRight: "12px",
                paddingY: "4px",
                ...sx,
            }}
        >
            <img
                src={DeliveryIcon}
                alt="DeliveryMethod"
                style={{ marginRight: "8px", width: "18px", height: "18px" }}
            />
            <Typography
                variant="h5"
                sx={{
                    whiteSpace: "nowrap",
                    color: "darkgrey",
                    fontFamily: "Roboto",
                    fontWeight: 500,
                    fontSize: "14px",
                    lineHeight: "18px",
                    letterSpacing: "0.1px",
                    textAlign: "center",
                }}
            >
                {text}
            </Typography>
        </Box>
    )
}

const StatusHeadOffice = (props: { text: string; sx?: SxProps }) => {
    const { text, sx } = props
    if (text === undefined || text.length == 0) return null

    return (
        <Box
            data-testid="status-head-office"
            sx={{
                width: "fit-content",
                height: "32px",
                borderRadius: "8px",
                backgroundColor: "grey.200",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                paddingLeft: "10px",
                paddingRight: "12px",
                paddingY: "4px",
                ...sx,
            }}
        >
            <img
                src={HeadOfficeIcon}
                alt="HeadOffice"
                style={{ marginRight: "8px", width: "18px", height: "18px" }}
            />
            <Typography
                variant="h5"
                sx={{
                    whiteSpace: "nowrap",
                    color: "darkgrey",
                    fontFamily: "Roboto",
                    fontWeight: 500,
                    fontSize: "14px",
                    lineHeight: "18px",
                    letterSpacing: "0.1px",
                    textAlign: "center",
                }}
            >
                {text}
            </Typography>
        </Box>
    )
}

const StatusBillingMethod = (props: { text: string; sx?: SxProps }) => {
    const { text, sx } = props
    if (text === undefined || text.length == 0) return null
    return (
        <Box
            data-testid="status-billing-method"
            sx={{
                width: "fit-content",
                height: "32px",
                borderRadius: "8px",
                backgroundColor: "grey.200",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                paddingLeft: "10px",
                paddingRight: "12px",
                paddingY: "4px",
                ...sx,
            }}
        >
            <img
                src={BillingMethodIcon}
                alt="BillingMethod"
                style={{ marginRight: "8px", width: "18px", height: "18px" }}
            />
            <Typography
                variant="h5"
                sx={{
                    whiteSpace: "nowrap",
                    color: "darkgrey",
                    fontFamily: "Roboto",
                    fontWeight: 500,
                    fontSize: "14px",
                    lineHeight: "18px",
                    letterSpacing: "0.1px",
                    textAlign: "center",
                }}
            >
                {text}
            </Typography>
        </Box>
    )
}

interface OreveStatusProps {
    variant?: "disabled" | "success" | "info" | "warning" | "error"
    icon?: React.ReactNode
    content: string
    sx?: object
}

export const OreveStatus = ({
    variant = "info",
    icon,
    content,
    sx = {},
}: OreveStatusProps) => {
    return (
        <Box
            sx={{
                width: "fit-content",
                height: "32px",
                borderRadius: "8px",
                bgcolor: `status.${variant}`,
                display: "flex",
                gap: "8px",
                alignItems: "center",
                paddingLeft: "10px",
                paddingRight: "12px",
                ...sx,
            }}
        >
            {icon !== undefined && icon}
            <Typography
                variant="labelLarge"
                sx={{
                    color: `${variant}.main`,
                }}
            >
                {content}
            </Typography>
        </Box>
    )
}

export {
    StatusDone,
    StatusDisable,
    StatusValidation,
    StatusWaiting,
    StatusError,
    StatusCharging,
    StatusDeliveryMethod,
    StatusHeadOffice,
    StatusBillingMethod,
    StatusWarning,
    StatusFailed,
}
